import { render, staticRenderFns } from "./newMaterialFaceRec.vue?vue&type=template&id=a8d4db72&scoped=true&"
import script from "./newMaterialFaceRec.vue?vue&type=script&lang=js&"
export * from "./newMaterialFaceRec.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialFaceRec.vue?vue&type=style&index=0&id=a8d4db72&lang=less&scoped=true&"
import style1 from "./newMaterialFaceRec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d4db72",
  null
  
)

component.options.__file = "newMaterialFaceRec.vue"
export default component.exports